import { ca } from '@cian/analytics';

export const trackNewbuildingFilterButtonClick = () => {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click_newbuilding_button',
    label: 'ListingJK',
  });
};

export const trackNewbuildingFilterMapClick = () => {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'go_to_map',
    label: '',
  });
};
